import { createSlice } from '@reduxjs/toolkit';

export const RECORD_STATE = {
  NOT_STARTED: 'NOT_STARTED',
  READY: 'READY',
  IN_PROGRESS: 'IN_PROGRESS',
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED',
  CREATED: 'CREATED',
};
export const FILE_TYPE = {
  VIDEO: 'VIDEO',
  SLIDE: 'SLIDE',
};
export const RECORD_READY_COUNT = 3; // 录制等待时间3s
export const MAX_RECORD_TIME = 30 * 60; // 最长录制时间，单位s
export const MAX_RECORD_TIME_FREE = 5 * 60; // 最长录制时间，单位s
export const MIN_RECORD_TIME = 3; // 最短录制时间，单位s

export const isVideoFile = (type) => type === FILE_TYPE.VIDEO;
export const isSlideFile = (type) => type === FILE_TYPE.SLIDE;

const initialState = {
  cameraOn: false,
  microphoneOn: false,
  screenOn: false,
  fileOn: false,
  fileType: null,
  fileVideoUrl: null,
  fileSlideUrls: [],
  state: RECORD_STATE.NOT_STARTED,
  volume: 0,
  cameraMirror: false,
};

export const recordingSlice = createSlice({
  name: 'recording',
  initialState,
  reducers: {
    openCamera: (state) => {
      state.cameraOn = true;
    },
    closeCamera: (state) => {
      state.cameraOn = false;
    },
    openMicrophone: (state) => {
      state.microphoneOn = true;
    },
    closeMicrophone: (state) => {
      state.microphoneOn = false;
    },
    openScreen: (state) => {
      state.screenOn = true;
    },
    closeScreen: (state) => {
      state.screenOn = false;
    },
    openFile: (state) => {
      state.fileOn = true;
    },
    closeFile: (state) => {
      state.fileOn = false;
    },
    setFileVideoUrl: (state, action) => {
      state.fileVideoUrl = action.payload;
    },
    setFileSlideUrls: (state, action) => {
      state.fileSlideUrls = action.payload;
    },
    setFileType: (state, action) => {
      state.fileType = action.payload;
    },
    switchRecordState: (state, action) => {
      state.state = action.payload;
    },
    setVolume: (state, action) => {
      state.volume = action.payload;
    },
    setCameraMirror: (state, action) => {
      state.cameraMirror = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  openCamera,
  closeCamera,
  openFile,
  closeFile,
  openMicrophone,
  closeMicrophone,
  openScreen,
  closeScreen,
  setFileVideoUrl,
  setFileSlideUrls,
  setFileType,
  switchRecordState,
  setVolume,
  setCameraMirror,
} = recordingSlice.actions;

export default recordingSlice.reducer;
